import { render, staticRenderFns } from "./PostModal.vue?vue&type=template&id=97eae220&scoped=true&"
import script from "./PostModal.vue?vue&type=script&lang=js&"
export * from "./PostModal.vue?vue&type=script&lang=js&"
import style0 from "./post-modal.css?vue&type=style&index=0&id=97eae220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eae220",
  null
  
)

export default component.exports